import StoreSettingsPage from './detail/StoreSettingsPage';
import IframeTab from './detail/IframeTab';

export default function StoreIframe() {
	return (
		<StoreSettingsPage title='Store - Iframe'>
			{(store) => <IframeTab store={store} />}
		</StoreSettingsPage>
	);
}
